/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';
import { UnitControl, type Size } from '@safe-wordpress/components';

/**
 * Control for letter-spacing.
 *
 * @param {Object}                  props                       Component props.
 * @param {boolean}                 props.__next40pxDefaultSize Start opting into the larger default height that will become the default size in a future version.
 * @param {string}                  props.value                 Currently selected letter-spacing.
 * @param {Function}                props.onChange              Handles change in letter-spacing selection.
 * @param {string|number|undefined} props.__unstableInputWidth  Input width to pass through to inner UnitControl. Should be a valid CSS value.
 *
 * @return {Element} Letter-spacing control.
 */
type LetterSpacingControlProps = {
	readonly value?: string | number;
	readonly onChange: ( value?: string ) => void;
	readonly __next40pxDefaultSize?: boolean;
	readonly __unstableInputWidth?: string;
	readonly size?: Size;
	readonly disabled?: boolean;
};
export function LetterSpacingControl( {
	__next40pxDefaultSize = false,
	value,
	onChange,
	__unstableInputWidth = '60px',
	...otherProps
}: LetterSpacingControlProps ): JSX.Element {
	return (
		<UnitControl
			__next40pxDefaultSize={ __next40pxDefaultSize }
			{ ...otherProps }
			label={ _x( 'Letter spacing', 'text', 'nelio-ab-testing' ) }
			value={ value }
			__unstableInputWidth={ __unstableInputWidth }
			onChange={ onChange }
		/>
	);
}
